import { render, staticRenderFns } from "./WidgetBase.vue?vue&type=template&id=967f9896&scoped=true&"
import script from "./WidgetBase.vue?vue&type=script&lang=js&"
export * from "./WidgetBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967f9896",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('967f9896')) {
      api.createRecord('967f9896', component.options)
    } else {
      api.reload('967f9896', component.options)
    }
    module.hot.accept("./WidgetBase.vue?vue&type=template&id=967f9896&scoped=true&", function () {
      api.rerender('967f9896', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/widgets/WidgetBase.vue"
export default component.exports